/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Closing_Scene_1Inputs */

const en_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On your commute`)
};

const de_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Pendeln`)
};

const zh_tw_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在通勤時`)
};

const zh_cn_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在通勤时`)
};

const es_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando vas de camino`)
};

const fr_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans les transports`)
};

const it_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In viaggio`)
};

const pt_br_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No trajeto`)
};

const ja_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通勤の合間に`)
};

const ko_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출퇴근길에`)
};

const ru_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда в дороге`)
};

const th_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตอนเดินทาง`)
};

const tr_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yolculukta`)
};

const ar_closing_scene_1 = /** @type {(inputs: Closing_Scene_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أثناء التنقّل`)
};

/**
* | output |
* | --- |
* | "On your commute" |
*
* @param {Closing_Scene_1Inputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const closing_scene_1 = /** @type {((inputs?: Closing_Scene_1Inputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closing_Scene_1Inputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_closing_scene_1(inputs)
	if (locale === "de") return de_closing_scene_1(inputs)
	if (locale === "zh_tw") return zh_tw_closing_scene_1(inputs)
	if (locale === "zh_cn") return zh_cn_closing_scene_1(inputs)
	if (locale === "es") return es_closing_scene_1(inputs)
	if (locale === "fr") return fr_closing_scene_1(inputs)
	if (locale === "it") return it_closing_scene_1(inputs)
	if (locale === "pt_br") return pt_br_closing_scene_1(inputs)
	if (locale === "ja") return ja_closing_scene_1(inputs)
	if (locale === "ko") return ko_closing_scene_1(inputs)
	if (locale === "ru") return ru_closing_scene_1(inputs)
	if (locale === "th") return th_closing_scene_1(inputs)
	if (locale === "tr") return tr_closing_scene_1(inputs)
	return ar_closing_scene_1(inputs)
});